import { defineStore } from 'pinia';

export const useEventStore = defineStore({
  id: 'eventStore',
  state: () => ({
    upcoming: [],
    past: [],
    cancelled: [],
    registrants: [],
    pastEventsEndDate: new Date()
  }),
  actions: {
    setPastEventsEndDate(d) {
      this.pastEventsEndDate = d;
    },
    setUpcomingEvents(events) {
      this.upcoming = events;
    },
    setPastEvents(events) {
      this.past = events;
    },
    setCancelledEvents(events) {
      this.cancelled = events;
    },
    setRegistrants(registrants) {
      this.registrants = registrants;
    },
  }
});
